import * as Yup from "yup";

export default Yup.object({
    hasManual: Yup.string().required("Please select the option"),
    dealerReviewMaintenanceProcedures: Yup.string().required("Please select the option"),
    dealerReviewSafetyProcedures: Yup.string().required("Please select the option"),
});
